import { useState } from "react";
import Loading from "../Loading";

const SrpSalesCenterRequest = () => {
    const [loading, setLoading] = useState(true);

    const hideSpinner = () => {
        setLoading(false);
    };

   return (
        <>
            {loading && <Loading />}
            <iframe title="SRP Sales Centre Requests"
                src={`${process.env.REACT_APP_SRP_SALES_CENTER_REQUEST_URL}`}
                onLoad={hideSpinner}
                hidden={loading ? true : false}
                allow="local-network-access"
            >
            </iframe>
        </>
    )
}

export default SrpSalesCenterRequest;
